import { VersionSelector } from "../VersionSelector";

interface DevotionalHeaderProps {
  date: string;
  topic: string;
  version: "classic" | "essential";
  onVersionChange: (version: "classic" | "essential") => void;
}

export const DevotionalHeader = ({
  date,
  topic,
  version,
  onVersionChange,
}: DevotionalHeaderProps) => {
  return (
    <div className="flex flex-col items-center justify-center w-full space-y-4">
      <VersionSelector version={version} onVersionChange={onVersionChange} />
      <div className="text-center w-full space-y-2">
        <p className="text-sage-600 font-medium">{date}</p>
        <h2 className="text-3xl font-serif font-bold text-sage-800 bg-sage-50 px-6 py-3 rounded-lg shadow-sm">
          TOPIC: {topic}
        </h2>
      </div>
    </div>
  );
};